/**
 * @generated SignedSource<<5a7d1c876b733b2ac680fe9f5899ea20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlainTextCellOld_PlainTextCellOld$data = {
  readonly id: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "PlainTextCellOld_PlainTextCellOld";
};
export type PlainTextCellOld_PlainTextCellOld$key = {
  readonly " $data"?: PlainTextCellOld_PlainTextCellOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlainTextCellOld_PlainTextCellOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PlainTextCellOld_PlainTextCellOld",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "21ef2273331f78548bbf59a012bb6b51";

export default node;
